export default [
  { to: '/tagging/explore', display: 'Tagged semantics' },
  { to: '/tagging/linguistics', display: 'Linguistics' },
  { to: '/tagging/linguistic-comparison', display: 'Linguistics comparison' },
  { to: '/tagging/symptoms', display: 'Symptoms playground' },
];
